import { render, staticRenderFns } from "./FoodCourtPayment.vue?vue&type=template&id=edd8b47a&scoped=true"
import script from "./FoodCourtPayment.vue?vue&type=script&lang=js"
export * from "./FoodCourtPayment.vue?vue&type=script&lang=js"
import style0 from "./FoodCourtPayment.vue?vue&type=style&index=0&id=edd8b47a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd8b47a",
  null
  
)

export default component.exports